var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "dashboard-menu" },
    [
      !_vm.authCheck
        ? _c(
            "router-link",
            {
              attrs: {
                to: { name: "login" },
                tag: "li",
                activeClass: "is-active"
              }
            },
            [
              _c("a", [
                _c("i", { staticClass: "fas fa-sign-in-alt" }),
                _vm._v("Login\n    ")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authCheck
        ? _c(
            "router-link",
            {
              attrs: {
                to: { name: "printers.index" },
                tag: "li",
                activeClass: "is-active"
              }
            },
            [
              _c("a", [
                _c("i", { staticClass: "fas fa-print" }),
                _vm._v("Printers\n    ")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.authCheck
        ? _c(
            "router-link",
            {
              attrs: {
                to: { name: "quotes.index" },
                tag: "li",
                activeClass: "is-active"
              }
            },
            [
              _c("a", [
                _c("i", { staticClass: "fas fa-file" }),
                _vm._v("Quotes\n    ")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "router-link",
        {
          attrs: {
            to: { name: "quotes.create" },
            tag: "li",
            activeClass: "is-active"
          }
        },
        [
          _c("a", [
            _c("i", { staticClass: "fas fa-envelope" }),
            _vm._v("Mail & Franking\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          attrs: {
            to: { name: "quotes.retrieve" },
            tag: "li",
            activeClass: "is-active"
          }
        },
        [
          _c("a", [
            _c("i", { staticClass: "fas fa-redo" }),
            _vm._v("Retrieve Quote\n    ")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.authCheck
        ? _c("li", { on: { click: _vm.logout } }, [_vm._m(0)])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("i", { staticClass: "fas fa-sign-out-alt" }),
      _vm._v("Logout\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bcc0be2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bcc0be2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = null
// module chunks = 